import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.element.setAttribute('novalidate', true);
  }

  onSubmit(e) {
    if (!this.element.checkValidity()) {
      e.preventDefault()
      e.stopPropagation()
    }
    this.element.classList.add('was-validated')
  }
}
